import { useQuery } from "@tanstack/react-query";
import galleriesMediaAPI from "../../api/galleries-media/api";

export function getQueryKey() {
  return ["galleries-media"];
}

export function useGetGalleriesMedia() {
  return useQuery({
    queryKey: getQueryKey(),
    queryFn: galleriesMediaAPI.getGalleriesMedia,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
